import logo from "../../../designs/images/external/straycity/logo.png";
import { i18nextT } from "../../../hooks/i18n/i18n";

import type { HostingStyleMap } from "utility/hosting";

/**
 * spwn basic style
 */
export const baseStyles = (): HostingStyleMap => {
  return {
    baseStyles: {
      baseColor: "#fff",
      mainColor: "#cc9999",
      accentColor: "#dc8c8c",
      fontPrimaryColor: "#000",
      fontSecondaryColor: "#000",
      backgroundImage: null,
    },

    commonSettings: {
      auth: {
        loginMethod: {
          twitter: true,
          facebook: false,
        },
      },
      route: {
        home: "/",
      },
      meta: {
        favicon: null,
        appleTouchIcon: null,
        title: i18nextT(
          "hosting.templates.stage-straycity-1.common.meta.title"
        ),
        description: null,
        copyright: i18nextT(
          "hosting.templates.stage-straycity-1.footer.copyright"
        ),
      },
      header: {
        logo: {
          isDisplay: true,
          path: logo,
        },
        textColor: "#fff",
        svgColor: "#fff",
      },
      menu: {
        home: {
          isDisplay: true,
        },
        event: {
          isDisplay: true,
          text: i18nextT(
            "hosting.templates.stage-straycity-1.common.section.event.name"
          ),
        },
        archive: {
          isDisplay: false,
          text: "",
        },
        account: {
          isDisplay: true,
        },
        pastEvents: {
          isDisplay: true,
          text: i18nextT(
            "hosting.templates.stage-straycity-1.common.section.pastEvents.name"
          ),
        },
        eventNotes: {
          isDisplay: true,
          path: null,
        },
        guide: {
          isDisplay: true,
        },
        contact: {
          isDisplay: true,
          path: null,
        },
      },
      isDisplayBreadcrumb: true,
      isDisplayEventDate: true,
      isDisplayEventTime: true,
    },

    pageSettings: {
      topPage: {
        upcomingHeadline: {
          isDisplay: true,
          mainText: "Stray Cityシリーズ「Club キャッテリア」",
          subText: null,
        },
        isDisplayTodaysEvent: false,
        isDisplayInfoArea: false,
        isDisplayDeliveryDisplayArea: false,
        isDisplayCatchCopy: false,
      },
      eventListPage: {
        /** -- 基本的にtrueで設定する -- */
        isDisplayEventDatetimeLabel: true,
        /** ------------------------- */
      },
      eventPage: {
        /** -- 基本的にtrueで設定する -- */
        isDisplayEventState: true,
        isDisplayEventTitle: true,
        isDisplayArtist: true,
        isDisplayShareButton: true,
        /** ------------------------- */
        linkInPage: {
          color: "#fff",
          link01: {
            isDisplay: true,
            text: i18nextT(
              "hosting.templates.stage-straycity-1.event.linkInEvent.link01.text"
            ),
          },
          link02: {
            isDisplay: false,
            text: "",
          },
          link03: {
            isDisplay: false,
            text: "",
          },
          link04: {
            isDisplay: true,
            text: i18nextT(
              "hosting.templates.stage-straycity-1.event.linkInEvent.link04.text"
            ),
          },
          link05: {
            isDisplay: false,
            text: "",
          },
        },
        artistInfo: {
          isDisplayArtistStateLabel: false,
          headline: {
            isDisplay: false,
            text: "",
            subText: "",
          },
        },
        purchaseButton: {
          path: null,
        },
      },
      goodsPage: {
        /** -- 基本的にtrueで設定する -- */
        isDisplayEventTitle: true,
        isDisplayArtist: true,
        isDisplayGoodsInfo: true,
        /** ------------------------- */
      },
      streamingPage: {
        isDisplaySuperChatArea: true,
      },
      accountTicketPage: {
        /** -- 基本的にtrueで設定する -- */
        isDisplayEventTitle: true,
        isDisplayArtist: true,
        isDisplayShareButton: true,
        /** ------------------------- */
      },
    },
  };
};
